import { useEffect } from "react";
import { Platform } from "react-native";

export const useMetaThemeColor = (isFocused: boolean, color: string) => {
  const changeMetaThemeColor = (color: string) => {
    const themeColorMetaTag = document.querySelector(
      'meta[name="theme-color"]'
    );
    if (themeColorMetaTag) {
      themeColorMetaTag.setAttribute("content", color);
    }
  };

  useEffect(() => {
    if (Platform.OS === "web") {
      if (isFocused) {
        changeMetaThemeColor(color);
      } else {
        changeMetaThemeColor("#FFFFFF");
      }
    }

    return () => {
      if (Platform.OS === "web") {
        changeMetaThemeColor("#FFFFFF");
      }
    };
  }, [isFocused, color]);
};

export default useMetaThemeColor;
